export enum ShopifyPackagingMode {
    AUTO = "Auto",
    ONE_PACKAGE = "OnePackage",
}

export enum ShopifySyncMode {
    AUTOMATIC = "Auto",
    MANUAL = "Manual",
}